import React, { useState, useRef, useEffect } from 'react';
import DefaultLogo from '../../assets/dummy/cards/puzzle.png';
import warningIcon from '../../assets/icons/warning.svg';
import HorizontalCardPanel from '../../components/shared/horizontal-cards-panel';
import Popup from '../../components/shared/popup';
import Icon from '../../components/shared/icon';
import getProducts from '../../redux/actions/products/getProducts';
import marked from 'marked';
import AuthService from '../../services/authService';

import { useTranslation } from 'react-i18next';
import { updateElsaPurchase } from '../../api-calls/products/products';
import { Container, Breadcrumb, Row, Col, Card } from 'react-bootstrap';
import { InfoBlock, ActiveBlock } from './sections';
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router";
import { withRouter } from 'react-router-dom';
import { useToasts } from 'react-toast-notifications';
import appLS from '../../constants/local-storage';

function DetailPage({ history, location }) {

  const { addToast } = useToasts();

  const { t: trans } = useTranslation();

  const [showModal, setShowModal] = useState(false);

  const [isAgreed, setIsAgreed] = useState(false);

  const { id: productId } = useParams();

  const product = useSelector(state => state.products.data.find(prod => prod.id === Number(productId)));

  const dispatch = useDispatch();
  const user = useSelector(state => state.user);

  const oidcUser = JSON.parse(localStorage.getItem(appLS.user));

  const currentDate = new Date().getTime();

  const myRef = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, myRef.current.offsetTop);
    }, 0)
  }, [])

  const handleActiveClick = () => {
    if (isInvalidUser) {
      handleLogin();
    }
    else {
      setShowModal(true);
    }
  }

  const handleClose = (isSave) => {
    if (isSave) {
      const elsaProduct = {
        ID: null,
        ProductID: product.id
      };
      updateElsaPurchase([elsaProduct]).then(res => {
        if (res) {
          addToast(trans('detail.success-integration'), { appearance: 'success', autoDismiss: true });
          // setting up correct status for all records
          dispatch(getProducts());
        }
      }).catch(e => {
        addToast(e.response.data, { appearance: 'error', autoDismiss: true })
      });
    }
    setShowModal(false)
  }

  const handleBreadcrumb = (category) => {
    if (category === 'home') {
      history.push('/');
    }
    else {
      history.push(`/?page=&category=${category.toLowerCase()}&search=`)
    }
  }

  const getMarkupContent = (markup) => {
    if (!markup) return;
    return marked.parse(decodeURI(markup));
  }

  const productInfo = {
    title: trans('detail.product-info.title'),
    list: [
      // { label: trans('detail.product-info.released'), value: '02/02/2019', isLink: false },
      // { label: trans('detail.product-info.updated'), value: '12/08/2019', isLink: false },
      { label: trans('detail.product-info.category'), value: product ? product.categoryName : '', isLink: true },
      { label: trans('detail.product-info.tags'), list: product ? product.tags : null, isLink: false }
    ]
  }

  const supportInfo = {
    title: trans('detail.support-info.title'),
    list: [
      { label: trans('detail.support-info.build-by'), value: product ? product.vendor ? product.vendor : '-' : '', isLink: false },
      // { label: trans('detail.support-info.email'), value: 'support@unimicro.no', isLink: false },
      // { label: trans('detail.support-info.web'), value: 'www.unimicro.no', isLink: false }
    ]
  }

  const handleLogin = () => {
    const authService = new AuthService();
    localStorage.setItem(appLS.redirectUrl, location.pathname);
    authService.login();
  }

  const handleConsent = (val) => {
    setIsAgreed(!val);
  }

  const isInvalidUser = Object.entries(user.data).length === 0 || !(oidcUser && oidcUser.expires_at > (currentDate / 1000));
  const isValidAdmin = user.data && user.data.IsAdministrator;
  const isValidConsentText = product?.productAgreement && product?.productAgreement.agreementText;
  const isValidAgreementDates = (Date.parse(product?.productAgreement?.validFromDate) < currentDate &&
    Date.parse(product?.productAgreement?.validToDate) > currentDate) ||
    (Date.parse(product?.productAgreement?.validFromDate) < currentDate && Boolean(!product?.productAgreement?.validToDate));

  const renderModalbody = <>
    {
      user.error ?
        <div className="invalid-activation">
          <Icon icon={warningIcon} classes="sm" />
          <h5>{trans('permission-issue.required')}</h5>
          <p>
            {trans('permission-issue.description')}
          </p>
        </div>
        : isInvalidUser ?
          <div className="invalid-activation">
            <Icon icon={warningIcon} classes="sm" />
            <h5>{trans('active-sign-in.required')}</h5>
            <p className='sign-in'>
              {trans('active-sign-in.please')}
              <span onClick={handleLogin}>{' ' + trans('active-sign-in.sign-in')}</span>
              {' ' + trans('active-sign-in.to-activate')}
            </p>
          </div>
          : isValidAdmin ?
            <>
              {
                isValidConsentText ?
                  isValidAgreementDates ?
                    <>
                      <p>
                        {trans('active-confirmation.activation-for')}
                        <span className='primary-span'> {product.label} </span>
                        {trans('active-confirmation.on-company')} -
                    <span className='primary-span'> {user.data.License.Company.Name}</span>
                      </p>
                      <div className="consent">
                        <p dangerouslySetInnerHTML={{ __html: getMarkupContent(product.productAgreement.agreementText) }} />
                        <div className="checkbox">
                          <input type="checkbox" checked={isAgreed} name="consent-cb" id="consent-cb" onChange={handleConsent.bind(null, isAgreed)} />
                          <label htmlFor="consent-cb">{trans('detail.consent')}</label>
                        </div>
                      </div>
                    </> :
                    <div className="invalid-activation">
                      <Icon icon={warningIcon} classes="sm" />
                      <h5>{trans('invalid-consent.title')}</h5>
                      <p >
                        {trans('invalid-consent.issue')}
                      </p>
                    </div>
                  :
                  <div className="invalid-activation">
                    <Icon icon={warningIcon} classes="sm" />
                    <h5>{trans('invalid-consent.title')}</h5>
                    <p >
                      {trans('invalid-consent.issue')}
                    </p>
                  </div>
              }
            </>
            :
            <div className="invalid-activation">
              <Icon icon={warningIcon} classes="sm" />
              <h5>{trans('active-error.title')}</h5>
              <p>{trans('active-error.role-issue')}</p>
            </div>
    }

  </>

  const getVideoMarkup = (url) => {

    // uses the same logic as used in app-frontend
    try {
      let vid;
      if (url.includes('youtu.be/')) {
        vid = url.split('youtu.be/')[1];
      } else if (url.includes('v=')) {
        const codePart = url.split('v=')[1];
        vid = codePart.split('&')[0];
      } else if (url.includes('/embed/')) {
        vid = url.split('/embed/')[1];
      }
      return <iframe
        src={`https://www.youtube.com/embed/${vid}`}
        width="560"
        height="315"
        frameBorder="0"
        allow="accelerometer;
              autoplay;
              encrypted-media;
              gyroscope;
              picture-in-picture"
        title='vid'
        allowFullScreen>
      </iframe>
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div className="detail-page" ref={myRef}>
      {product &&
        <>
          <Popup classes="activation-popup"
            title={trans('active-confirmation.title')}
            isValidSave={
              !isInvalidUser && isValidAdmin && isValidConsentText && isValidAgreementDates}
            showModal={showModal} handleClose={handleClose}
            body={renderModalbody}
            saveBtn={trans('common-action.confirm')}
            isValid={isAgreed}
            closeBtn={trans('common-action.close')}
          />
          <div className="header-container">
            <div className="bread-crub-wrapper">
              <Breadcrumb>
                <Breadcrumb.Item onClick={handleBreadcrumb.bind(null, 'home')}>
                  {trans('detail.bread-crumb.marketplace')}
                </Breadcrumb.Item>
                <Breadcrumb.Item onClick={handleBreadcrumb.bind(null, product.categoryName)}>
                  {product.categoryName}
                </Breadcrumb.Item>
              </Breadcrumb>
              <h3>{product.label}</h3>
            </div>
          </div>
          <Container className="detail-container">
            <Row>
              <Col lg={8} className="detail-overview">
                <Row className="header">
                  <Card>
                    <Card.Body>
                      <section className='top-section'>
                        <h2>{product.label}</h2>
                        <figure>
                          <img src={product.iconReference ? product.iconReference : DefaultLogo} alt="integration-logo" />
                        </figure>
                      </section>
                      <section className='desc-section'>
                        <p>{product.description}</p>
                      </section>
                      <section className='content-section'>
                        {getMarkupContent(product.markdownContent) || product.imageReference || product.videoUrl ?
                          <>
                            {
                              getMarkupContent(product.markdownContent) &&
                              <div dangerouslySetInnerHTML={{ __html: getMarkupContent(product.markdownContent) }} />
                            }
                            {
                              product.imageReference &&
                              <figure className='image-refference'>
                                <img src={product.imageReference} alt='refference' />
                              </figure>
                            }
                            {
                              product.videoUrl &&
                              getVideoMarkup(product.videoUrl)
                            }
                          </>
                          :
                          <p className='not-found'>{trans('common-action.content-not-found')}</p>
                        }
                      </section>
                      {/* <figure className="cover" style={{ backgroundColor: product.iconBackgroundColor ? product.iconBackgroundColor : '#fff' }}>
                        <img src={product.iconReference ? product.iconReference : DefaultLogo} alt="integration-logo" />
                      </figure>
                      <div className="top-description-wrapper">
                        <h3>{product.label}</h3>
                        <p>{product.description}</p>
                      </div> */}
                    </Card.Body>
                  </Card>
                </Row>
              </Col>
              <Col lg={4} className="info">
                <ActiveBlock
                  canActivate={product.canActivate}
                  btnUrl={product.buttonLink}
                  isBought={product._isBought}
                  handleClick={handleActiveClick}
                  price={`kr. ${product.price}-`}
                  isFree={product.price === 0}
                  summary={`${trans('detail.purchase.sold-as')}
                  ${product.isMonthly ? trans('detail.purchase.monthly') : trans('detail.purchase.transaction')}`
                  }
                />
                <InfoBlock title={productInfo.title} list={productInfo.list} />
                <InfoBlock title={supportInfo.title} list={supportInfo.list} />
              </Col>
            </Row>
          </Container>
          <div className="secondary-content" >
            <Container>
              <HorizontalCardPanel icon={DefaultLogo} />
            </Container>
          </div>
        </>
      }
    </div>
  );
}

export default withRouter(DetailPage);